// extracted by mini-css-extract-plugin
export var viewMore = "styles-module--viewMore--eARyy";